import type { ReactNode } from 'react';
import { LAYOUT_SHELL } from './tokens';

interface AppShellProps {
  children: ReactNode;
  /** Glows decorativos (home, login). */
  ambient?: boolean;
  /** Sobrescreve classes do shell (ex.: Admin Master `bg-[#0a0c10]`). */
  className?: string;
  /** `row` para layout com sidebar lateral (Admin Master). */
  direction?: 'col' | 'row';
}

export function AppShell({
  children,
  ambient = false,
  className = '',
  direction = 'col',
}: AppShellProps) {
  return (
    <div
      className={`${LAYOUT_SHELL} ${direction === 'row' ? 'flex-row' : 'flex-col'} ${className}`.trim()}
    >
      {ambient && (
        <div className="pointer-events-none fixed inset-0 overflow-hidden" aria-hidden="true">
          <div className="absolute -top-24 left-1/2 h-72 w-72 -translate-x-1/2 rounded-full bg-orange-500/[0.07] blur-3xl sm:h-96 sm:w-96" />
          <div className="absolute bottom-0 right-0 h-48 w-48 rounded-full bg-blue-500/[0.04] blur-3xl" />
        </div>
      )}
      {children}
    </div>
  );
}
